export const MatchRoutePaths = {
  root: {
    default: 'spiele/:eventId/:teamId',
  },
  Infos: 'infos',
  Ticker: 'ticker',
  Overview: 'overview',
  Lineup: 'lineup',
  Table: 'table',
  Timeline: 'timeline',
  Videos: 'videos',
};
